<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.term_id" class="modal-card-title">Crear Termino y Condiciones</p>
          <p v-else class="modal-card-title">Editar Termino y Condiciones</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Titulo">
            <b-input
              type="text"
              :value="term.title"
              v-model="term.title"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <!-- <b-field label="Texto"            >
            <b-input :value="term.message" v-model="term.message" type="textarea"></b-input>
        </b-field> -->
          <b-field label="Texto"            >
            <wysiwyg v-model="term.message" />
        </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.term_id" class="button is-primary" @click="createTerm()">Guardar</button>
          <button v-else class="button is-primary" @click="editTerm()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeTermsList",
    "term_id",
  ],
  data() {
    return {
      term: {
        title: "",
        message:"",
      },
      isLoading: false,
    };
  },
  created: function () {
    this.isLoading = true;
    if (this.term_id) {
      this.chargeStablishmentData().then(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    createTerm: async function () {
      this.isLoading = true;
      let data = {
        ...this.term,
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/term`, data).then(
        (response) => {
          //Limpia el objeto term
          for (const i in this.term) {
            this.term[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeTermsList();
          this.closeBasic();
          this.toast("Creado el Termino y Condiciones", "is-success");
          this.isLoading = false;
        },
        (response) => {
          this.toast("Error al crear", "is-danger");
          this.isLoading = false;
          console.log("error: ", response);
        }
      );
    },
    editTerm: function () {
      this.isLoading = true;
      let data = {
        ...this.term,
      };
      this.$http
        .put(`api/${localStorage.getItem('perfil')}/term/` + this.term_id, data)
        .then(
          (response) => {
            //Limpia el objeto prevition
            for (const i in this.term) {
              this.term[i] = "";
            }
            console.log("PUT:", response.body);
            this.chargeTermsList();
            this.closeBasic();
            this.toast("Editado el Termino y Condiciones", "is-success");
            this.isLoading = false;
          },
          (response) => {
            this.toast("Error al editar", "is-danger");
            this.isLoading = false;
            console.log("error: ", response);
          }
        );
    },
    chargeStablishmentData: async function () {
      await this.$http
        .get(`api/${localStorage.getItem('perfil')}/term/` + this.term_id)
        .then(
          (response) => {
            this.term.title = response.body.term.title;
            this.term.message = response.body.term.message;
          },
          (response) => {
            console.log(response);
          }
        );
    },
  },
};
</script>